exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4[data-v-dfc5539c]{font-size:14px;font-weight:bolder;color:#000;line-height:21px;text-align:start}p[data-v-dfc5539c]{font-size:13px;margin:0 0 10px 45px}.img-div[data-v-dfc5539c]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:10px 5px 10px 5px}.icon[data-v-dfc5539c]{width:30px;height:25px;margin-right:10px}.go-home-btn[data-v-dfc5539c]{margin-top:10px}", ""]);

// exports
